<!-- 机器人富文本消息，对应webim的 5-4 -->
<template>
  <div :data-msg-type="msgType">
    <template v-if="msgType === 1">
      <div v-if="isBtnList">
        <!-- a. 带快捷回复按钮 -->
        <div class="btn-title" v-html="btnListData.title"></div>
        <div class="bubble-btn" v-html="btnListData.list.join('')"
          :class="`bubble-btn-cnt-${btnListData.list.length}`"></div>
      </div>
      <!-- b. 默认模式下，和htmlmsg无区别 -->
      <div v-else v-html="msgContent" class="richmsg-type-5"></div>
    </template>
    <template v-else><!-- c. qlist-msg，类似batch-msg -->
      <div class="qlist-content">
        <div class="qlist-title" v-html="qlist.title"></div>
        <div class="qlist-list" v-html="qlist.list.join('')"></div>
      </div>
    </template>
  </div>
</template>

<script>
import robotMsgFilter from '@/utils/robotMsgFilter';
import Utils from '@/utils/string';

export default {
  props: {
    message: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {};
  },

  computed: {
    msgData() {
      return this.message.content;
    },

    // 过滤消息内容
    msgContent() {
      let { content } = this.message.content;
      content = Utils.coverEmojIndex2EmojiImg(robotMsgFilter(content));
      return content;
    },

    // 1-普通机器人自由文本消息 2-机器人推荐问题消息 3-机器人关联问题消息
    msgType() {
      return this.message.content.msgType || 1;
    },

    qlist() {
      return this.parseQList(this.msgContent);
    },

    isBtnList() {
      return this.msgContent.indexOf('quick-relply-btn') > -1;
    },

    btnListData() {
      return this.parseBtnList(this.msgContent);
    },
  },

  methods: {
    /**
     * 解析qlist数据，最终解析出来一堆<a>节点
     */
    parseQList(content) {
      const LINK_REG = /(<a[^>]*?>)(.*?)(<\/a>)/g;
      const ret = {
        title: '',
        list: [],
      };

      let index = 0;
      let link = null;

      while (link = LINK_REG.exec(content)) {
        if (index === 0) {
          index = link.index;
        }
        if (link.length >= 4) {
          ret.list.push(`${link[1]}<span title="${link[2]}">${link[2]}</span>${link[3]}`);
        }
      }

      if (index) {
        ret.title = robotMsgFilter(content.slice(0, index));
      }

      return ret;
    },

    /**
     * 解析btnList
     * return obj = {title, list:[]}
     */
    parseBtnList(content) {
      const LINK_REG = /(<a[^>]*?quick-relply-btn[^>]*?>)(.*?)(<\/a>)/g;

      const ret = {
        title: '',
        list: [],
      };

      let index = 0;
      let link = null;

      while ((link = LINK_REG.exec(content))) {
        if (index === 0) {
          index = link.index;
        }
        if (link.length >= 4) {
          ret.list.push(`${link[1]}<span title="${link[2]}">${link[2]}</span>${link[3]}`);
        }
      }

      if (index) {
        ret.title = robotMsgFilter(content.slice(0, index));
      }

      return ret;
    },
  },
};
</script>

<style lang="less" scoped>
.richmsg-type-5 {
  font-size: 14px;
  line-height: 1.4;
  word-break: break-word;
  word-wrap: break-word;
  // max-width: 230px;

  ::v-deep img {
    max-width: 100%;
  }
}

// 快捷回复按钮
// 这里未和webim对齐，因为要处理就要重新整个消息结构。。。太恶心了。。怎么会有这样的设计效果。
.bubble-btn {
  @c: @primary;
  ::v-deep .quick-relply-btn {
    display: inline-block;
    color: @c;
    font-size: 13px;
    line-height: 20px;
    padding: 1px 12px;
    border: 1px solid @c;
    border-radius: 20px;
    margin-right: 8px;
    margin-top: 8px;
    background: #fff;
    text-decoration: none;

    &:hover {
      color: #fff;
      background: @c;
    }
  }
}

.qlist-content {
  width: 256px;
  .qlist-title {
    color: #a8abb3;
    font-size: 12px;
  }
  .qlist-list {
    ::v-deep a {
      position: relative;
      display: block;
      color: @primary;
      font-size: 13px;
      padding: 1px 0;

      span {
        display: block;
        line-height: 20px;
        max-height: 40px;
        overflow: hidden;

        display: -webkit-box;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }

      &:last-child {
        border-bottom: 1px solid transparent;
        margin-bottom: -5px;
      }

      &::after {
        content: '';
        position: absolute;
        width: 5px;
        height: 10px;
        top: 50%;
        right: 0;
        margin-top: -5px;
        background-image: url('~../assets/arrow.svg');
      }
    }
  }
}
/deep/
.emojiText-image {
  height: 20px;
  vertical-align: top;
  min-width: 20px;
  max-width: 20px;
}
.pc.pc-not-frame {
  .richmsg-type-5 {
    font-size: 15px;
    /deep/
    .emojiText-image {
      height: 21px;
      min-width: 21px;
      max-width: 21px;
    }
  }
  .bubble-btn {
    ::v-deep .quick-relply-btn {
      font-size: 14px;
      line-height: 22px;
    }
  }
  .qlist-content {
    .qlist-title {
      font-size: 13px;
    }
    .qlist-list {
      ::v-deep a {
        font-size: 14px;
      }
    }
    /deep/
    .emojiText-image {
      height: 21px;
      min-width: 21px;
      max-width: 21px;
    }
  }
}
</style>
